/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBarberShiftAppointmentsOutput } from "../../entities/models/BarberShiftAppointmentsOutput";
import { modelsBarberShiftAppointmentSchema } from "./barberShiftAppointmentSchema";
import { z } from "zod/v4";

export const modelsBarberShiftAppointmentsOutputSchema = z.object({
    get "appointments"(){
                return z.array(modelsBarberShiftAppointmentSchema).optional()
              }
    }) as unknown as z.ZodType<ModelsBarberShiftAppointmentsOutput>